'use client'
import {ChangeEvent} from 'react'
import {DatePicker} from 'react-date-picker'
import {useEscapeKey, useFocusTrap} from '@local/hooks'
import {Select, SelectOptionType} from '@local/ui/components'
import {cx} from '@local/utils/cx'
import PersonSVG from '@local/assets/svgs/icon-person.svg'
import DateSVG from '@local/assets/svgs/icon-date.svg'

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

export interface HotelEnquireMobileSelectProps {
	isOpen: boolean
	guestOptions: SelectOptionType[]
	guestCounts: string
	onClickClose: () => void
	onChangeGuests: (e: ChangeEvent<HTMLSelectElement>) => void
	onChangeArrivalDate: (v: Value) => void
	onChangeDepartureDate: (v: Value) => void
	arrivalDate: Value
	departureDate: Value

}

export const HotelEnquireMobileSelect = ({
	isOpen,
	guestOptions,
	guestCounts,
	onClickClose,
	onChangeArrivalDate,
	onChangeDepartureDate,
	arrivalDate,
	departureDate,
	onChangeGuests,

}: HotelEnquireMobileSelectProps) => {
	const trapRef = useFocusTrap({
		includeContainer: true,
		initialFocus: 'container',
		returnFocus: true,
		updateNodes: true,
		isActive: isOpen,
		onClickClose,
	})

	useEscapeKey(onClickClose)

	return (
		<>
			<div
				ref={trapRef}
				className={cx(
					'lg:hidden',
					'fixed bottom-66 margin-left-1 margin-right-1 z-10',
					'flex flex-col gap-12 bg-white rounded-xs p-10',
					'transform-gpu transition-[transform,opacity,visibility] origin-bottom duration-300 ease-expo-out',
					isOpen
						? 'scale-100 opacity-100 visible'
						: 'scale-90 opacity-0 invisible',
				)}>
				<DatePicker
					onChange={onChangeArrivalDate}
					value={arrivalDate}
					locale='en-US'
					format={arrivalDate ? 'Arrival: dMMM' : 'Arrival Date'}
					minDate={new Date()}
					calendarProps={{
						next2Label: null,
						prev2Label: null,
						nextLabel: null,
						prevLabel: null,
					}}
					calendarIcon={<DateSVG className='col-start-1 row-span-full w-16 h-16' />}
					clearIcon={false} />
				<DatePicker
					onChange={onChangeDepartureDate}
					value={departureDate}
					locale='en-US'
					format={departureDate ? 'Departure: dMMM' : 'Departure Date'}
					minDate={new Date()}
					calendarProps={{
						next2Label: null,
						prev2Label: null,
						nextLabel: null,
						prevLabel: null,
					}}
					calendarIcon={<DateSVG className='col-start-1 row-span-full w-16 h-16' />}
					clearIcon={false} />

				<Select
					theme='light'
					name='mobileGuest'
					id='hotel-enquire-mobile-guest-select'
					onChange={onChangeGuests}
					options={guestOptions}
					value={guestCounts}
					prefixIcon={<PersonSVG className='w-16 h-16 mr-4' alt='Person Icon' />}
					titleClassName='!text-9 font-medium'
					containerClassName='w-full mt-2' />

			</div>
			<div
				onClick={onClickClose}
				className={cx(
					'lg:hidden',
					'absolute z-0 inset-0 bg-black/10',
					'transition-[opacity,visibility] duration-500',
					isOpen ? 'opacity-10 visible ease-quart-out' : 'opacity-0 invisible ease-quart-inout',
				)} />
		</>
	)
}
